import { DataGrid, esES } from "@mui/x-data-grid";
import { useState } from "react";

const Table = ({
  data,
  rowClick,
  loading,
  render,
  getRowClassName,
  search,
  height = 400,
  msAutoSerach = true,
  onSelectionModelChange,
  renderButtonFooter,
  rowHeight = null,
  sx,
}) => {
  const { rows, columns, filter } = data;
  const [state, setState] = useState("");

  const changeValue = ({ target: { value } }) => setState(value);

  const arrayValue = state.toLowerCase().trim().split(" ");

  const newFilter = (arrayValue, data) => {
    arrayValue = arrayValue.filter((elemento) => elemento !== "");

    while (arrayValue.length) {
      data = data.filter((el) => fiterByProperty(el, arrayValue));
      arrayValue.splice(0, 1);
    }

    return data;
  };

  const fiterByProperty = (el, a) => {
    for (const key in el) {
      if (el.hasOwnProperty(key) && el[key]) {
        const attribute = el[key].toString().toLowerCase();
        if (attribute.includes(a[0])) return true;
      }
    }
    return false;
  };

  return (
    <>
      {search && (
        <div className="card mb-1 d-flex flex-row">
          {render && render()}
          <div className={`d-flex flex-row p-2 ${msAutoSerach && "ms-auto"}`}>
            <input
              disabled={loading}
              id="search"
              type="search"
              className="form-control"
              value={state}
              placeholder="Buscar..."
              onChange={changeValue}
            />
          </div>
        </div>
      )}

      <div style={{ height, width: "100%" }} className="d-flex position-relative">
        {renderButtonFooter && (
          <div className="position-absolute z-3" style={{ bottom: "15px", left: "10px" }}>
            {renderButtonFooter()}
          </div>
        )}
        <DataGrid
          onRowClick={
            rowClick
              ? rowClick
              : () => {
                  console.log("hola");
                }
          }
          // rows={rows.filter((el) => filter(el, state))}
          rows={newFilter(arrayValue, rows)}
          columns={columns}
          pageSize={10}
          loading={loading}
          /* disableSelectionOnClick */
          /* rowsPerPageOptions={[10]} */
          rowHeight={rowHeight}
          density="compact"
          disableColumnMenu
          hideFooterSelectedRowCount
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            ".MuiDataGrid-cell:focus": {
              outline: "none",
            },
            // pointer cursor on ALL rows
            "& .MuiDataGrid-row:hover": {
              cursor: "pointer",
            },
            ...sx,
          }}
          keepNonExistentRowsSelected
          checkboxSelection={onSelectionModelChange ? true : false}
          onSelectionModelChange={onSelectionModelChange ? onSelectionModelChange : () => {}}
          getRowClassName={getRowClassName ? getRowClassName : () => {}}
        />
      </div>
    </>
  );
};

export default Table;
